import { ErrorMessage } from '@hookform/error-message';
import { css } from '@emotion/react';

interface Props {
  errors: { [x: string]: any };
  name: string;
  msg?: string;
}

function ErrorMsg(props: Props): JSX.Element {
  const { errors, name, msg } = props;

  /* Define state / hook */

  /* Custom Data Object for render or other usages */

  /* Render control function / logic */

  /* Data Change Listeners - useEffect/useMemo/useCallback */

  /* Styling */

  /* Render */
  return (
    <ErrorMessage
      errors={errors}
      name={name}
      render={({ message }) => (
        <p
          css={css`
            color: #ee6666;
            margin-top: 0.2em;
          `}
        >
          {msg || message}
        </p>
      )}
    />
  );
}

export default ErrorMsg;
